import * as React from 'react';
import { Button, LinkButton } from '@cian/ui-kit';

import * as styles from './OffersListDesktop.css';
import { useInView } from 'react-intersection-observer';

interface IOffersListDesktopProps {
  url?: string;
  onShow?(): void;
  onMoreClick?(): void;
  hideShowMoreButton?: boolean;
}

const ShowMoreButton = ({ onMoreClick, url }: { onMoreClick?: () => void; url: string }) => {
  if (!onMoreClick) {
    return <Button data-name="MoreLinkLoading" size="L" theme="fill_secondary" fullWidth loading />;
  }

  return (
    <LinkButton
      data-name="MoreLink"
      size="L"
      theme="fill_secondary"
      fullWidth
      onClick={onMoreClick}
      href={url}
      target="_blank"
    >
      Посмотреть ещё
    </LinkButton>
  );
};

export const OffersListDesktop: React.FC<React.PropsWithChildren<IOffersListDesktopProps>> = ({
  url = '',
  children,
  onShow,
  onMoreClick,
  hideShowMoreButton = false,
}) => {
  const [isShown, setIsShown] = React.useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onShow && !isShown) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown]);

  return (
    <div className={styles['container']} ref={ref}>
      <div className={styles['list']}>{children}</div>
      {!hideShowMoreButton && <ShowMoreButton onMoreClick={onMoreClick} url={url} />}
    </div>
  );
};
